import script from "./FeedDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedDetail.vue?vue&type=script&setup=true&lang=js"

import "./FeedDetail.vue?vue&type=style&index=0&id=01d1c6d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d1c6d8"]])

export default __exports__